const drawState = {
	NONE: 'none',
	START: 'start',
	END: 'end',
	AREAPOLYGON: 'areaPolygon',
	OBSTACLES: 'obstacles',
	POINTS: 'points',
}
export default drawState;

export function doNotAutochangeState(comparedDrawState) {
	return (comparedDrawState === drawState.OBSTACLES);
}